import request from '@/utils/request'

// 登录
export function loginApi(data) {
  return request.post('/login', data)
}

// 注册
export function registerApi(data) {
  return request.post('/register', data)
}

// 退出登录 data , { params: data }
export function logout() {
  return request.get('/v1/logout')
}
